var configuratorStarted = false
var shopifyConfiguratorInterval = setInterval(function () {
  if ($) {
    clearInterval(shopifyConfiguratorInterval)

    if (configuratorStarted) {
      return
    }

    var hasProduct = false
    if (location.pathname === '/products/sternschnuppe-silbernova') {
      hasProduct = true
    } else if (location.pathname === '/products/sternschnuppe-supernova') {
      hasProduct = true
    } else if (location.pathname === '/products/sternschnuppe-goldnova') {
      hasProduct = true
    }

    if (!hasProduct) {
      return
    }

    $(document).ready(function () {
      configuratorStarted = true

      var config = {}

      config['silbernova'] = {
        product: '5057306427527',
        locale: 'de-DE',
        variantButtonSelector: { title: 'Wähle dein Urkunden-Design', key: '_design' },
        formElements: [
          //Elemente:
          {
            element: 'name',
            key: 'Taufname',
            title: 'Taufname',
            subTitle: 'Geben Sie den Namen Ihres Sterns an',
            charactersLeftText: 'Zeichen übrig',
            maxCharacters: 25,
            isMandatory: true,
            enableNextAfterInput: true
          },
          {
            element: 'date_picker',
            key: 'Taufdatum',
            title: 'Taufdatum',
            subTitle: 'Wählen Sie Das Taufdatum aus',
            isMandatory: true,
            placeholderText: 'Datum auswählen...',
            isShowFormatButtons: false
          },
          {
            element: 'text',
            key: 'Grusskarte',
            product: '6625405599879',
            title: 'Ihre persönliche Nachricht',
            subTitle: 'Ihre persönliche Nachricht auf einer Grusskarte',
            charactersLeftText: 'Zeichen übrig',
            maxCharacters: 150,
            isMandatory: false
          },
          {
            element: 'product_image_select',
            title: 'Helligkeit und Sichtbarkeit des Sterns',
            isMandatory: true,
            subTitle:
              'Helle und vor allem sehr helle Sterne sind besonders gut und sogar in Städten mit viel Lichtverschmutzung sichtbar.',
            isShowUpsell: false, // default: true,
            upsellCheck: 'by-price',
            upsellProduct: '6687094669447',
            upsellTeaserText:
              'Günstiger stärkere Helligkeit auswählen!<br>Jetzt dein Taufzertifikat upgraden',
            upsellSubmitText: 'Helleren Stern speichern',
            upsellCancelText: 'Nein, ich möchte keinen helleren Stern',
            product: '6625415954567',
            variants: [
              {
                number: '39576346525831',
                upsellNumber: '39832281284743',
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/t/22/assets/brightness_normal.jpg?v=1635715232',
                isActive: false
              },
              {
                number: '39576346558599',
                upsellNumber: '39832281317511',
                upsellNumber2: '44470271508748',
                image: '',
                upsellProduct: '8371758006540',
                upsellCheck: 'by-existence'
              },
              {
                number: '39576346591367',
                upsellNumber: '39832281350279',
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/t/22/assets/brightness_very_bright.jpg?v=1635715259'
              }
            ]
          },
          {
            element: 'email',
            key: 'Email',
            title: 'Email für die digitale Zustellung',
            subTitle:
              'Geben Sie die E-Mail-Adresse ein, an die wir die digitalen Dokumente senden können.',
            maxCharacters: 100,
            isMandatory: false,
            isDigital: true,
            enableNextAfterInput: true,
            url: 'https://api.space-registry.org/api/v1/tracking/shopify/customers',
            domain: 'www.galaxieregister.de'
          },
          {
            element: 'product_image_select',
            title: 'Bilderrahmen für Ihre Urkunde',
            canDeselect: false,
            isShowUpsell: false,
            upsellCheck: 'by-quantity',
            upsellProduct: '6687094702215',
            product: '5286600474759',
            variants: [
              {
                number: '34903301226631',
                upsellNumber: '39832281383047',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/t/22/assets/frame_black.png?v=1635715272',
                isActive: false
              },
              {
                number: '34903301193863',
                upsellNumber: '39832281415815',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/t/22/assets/frame_white.png?v=1635715281'
              },
              {
                number: '39751336558727',
                upsellNumber: '39832281448583',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/files/Product_icons_star_naming_39.png?v=1695385578'
              }
            ]
          },
          {
            element: 'product_additional',
            title: 'Zusätzliche Ausführung',
            key: '_product_additional',
            subTitle: 'Zusätzliches Zertifikat, Mappe, Sternkarte & Grußkarte',
            product: '6625414217863',
            maxQuantity: 50,
            canChangeCartQuantity: true
          },
          {
            element: 'product_choose',
            key: '_is_digital',
            title: 'Zertifikat vorab per Mail',
            subTitle: 'Lieferung des Zertifikates innerhalb von 24 Stunden vorab als PDF (Mail)',
            buttonTextYes: 'Ja',
            buttonTextNo: 'Nein',
            product: '6625409040519',
            isMandatory: true
          }, //isYes:false
          {
            element: 'product_choose',
            hideIfNoText: true,
            title: 'Rechtschreibprüfung der Widmung',
            buttonTextYes: 'Ja',
            buttonTextNo: 'Nein',
            product: '6625406451847',
            isMandatory: true
          },
          {
            element: 'image_select_slider',
            title: 'Mizodia Sternzeichenkette',
            subTitle: 'Vergoldete Sternzeichenkette (100% Wasserfest & Allergiefreundlich)',
            tooltipText: 'Vergoldete Sternzeichenkette (100% Wasserfest & Allergiefreundlich)',
            isMandatory: false,
            selectText: 'Hier auswählen',
            deselectText: 'Ohne',
            canDeselect: true,
            showImages: true,
            product: '5210005962887',
            hasNoBorder: true,
            isCompact: true
          },
          {
            element: 'image_select_slider',
            title: 'Mizodia Premiumkette mit persönlicher Gravur',
            subTitle:
              'Vergoldete Premium-Sternzeichenkette mit persönlicher Gravur (Sternname, Taufdatum & Sternkoordinaten)',
            tooltipText: 'Vergoldete Sternzeichenkette (100% Wasserfest & Allergiefreundlich)',
            isMandatory: false,
            selectText: 'Hier auswählen',
            deselectText: 'Ohne',
            canDeselect: true,
            showImages: true,
            product: '8508688171276',
            hasNoBorder: true,
            isCompact: true
          }
        ],
        giftProducts: [
          { product: '6687805505671' }
          //Beispiel, Produkt mit mehreren Varianten, bestimmte Variante als Geschenk auswählen: { product:'7352744313056', number:'42545842749664' }
        ],
        translations: [{ totalLabel: 'Total inkl. 19% MwSt.' }],
        shippingInfoText: '',
        shippingInfoHtml: ''
      }

      var sternschnuppeBaseConfig = {
        product: '',
        upsellTitle: 'Wähle einen größeren Meteoritenstein - 50% Rabatt',
        upsellSubTitle: 'Jetzt größere Sternschnuppe wählen',
        upsellTeaserText:
          'Günstiger größeren Meteoritenstein auswählen!<br>Jetzt deine Besitzurkunde upgraden',
        upsellSubmitText: 'Größerer Meteoritenstein speichern',
        upsellCancelText: 'Nein, ich möchte keinen größeren Meteoritenstein',
        basketGroupTitleOverwrite: 'Deine personalisierte Sternschnuppe',
        changeNamesAfterVariantSwitch: true,
        variantButtonSelector: { title: '', key: '', isIgnoreTemplate: true, isMandatory: false },
        locale: 'de-DE',
        formElements: [
          {
            element: 'name',
            key: 'Vorname',
            title: 'Name des Eigentümers',
            isDigital: true,
            subTitle: 'Name eintragen oder freilassen und handschriftlich selbst eintragen',
            charactersLeftText: 'Zeichen übrig',
            maxCharacters: 25,
            isMandatory: false,
            enableNextAfterInput: true
          },
          {
            element: 'text',
            product: '6625405599879',
            showImage: true,
            key: 'Grusskarte',
            title: 'Grußkarte hinzufügen',
            isDigital: false,
            subTitle: 'Ihre persönliche Widmung auf einer Grußkarte',
            charactersLeftText: 'Zeichen übrig',
            maxCharacters: 150,
            isMandatory: false,
            isShowUpsell: false,
            upsellCheck: 'by-quantity',
            upsellProduct: '8009190834444',
            upsellTeaserText: 'Jetzt Widmung für deine Sternschnuppe schreiben',
            upsellSubmitText: 'Widmung speichern',
            upsellCancelText: 'Nein, ich möchte keine Widmung schreiben',
            upsellOverwriteIntroTitle: 'Sternschnuppe für'
          },
          {
            element: 'product_image_select',
            title: 'Bilderrahmen für Ihre Besitzurkunde',
            canDeselect: false,
            product: '5286600474759',
            variants: [
              {
                number: '34903301226631',
                upsellNumber: '39832281383047',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/t/22/assets/frame_black.png?v=1635715272',
                isActive: false
              },
              {
                number: '34903301193863',
                upsellNumber: '39832281415815',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/t/22/assets/frame_white.png?v=1635715281'
              },
              {
                number: '39751336558727',
                upsellNumber: '39832281448583',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0381/7504/7815/files/Product_icons_star_naming_39.png?v=1695385578'
              }
            ]
          },
          {
            element: 'image_select_slider',
            title: 'Mizodia Sternzeichenkette',
            subTitle: 'Vergoldete Sternzeichenkette (100% Wasserfest & Allergiefreundlich)',
            isMandatory: false,
            selectText: 'Hier auswählen',
            deselectText: 'Ohne',
            canDeselect: true,
            showImages: true,
            isDigital: false,
            tooltipText: 'Vergoldete Sternzeichenkette (100% Wasserfest & Allergiefreundlich)',
            product: '5210005962887',
            hasNoBorder: true,
            isCompact: true,
            isShowUpsell: false,
            upsellCheck: 'by-quantity',
            upsellProduct: '8003544088844',
            upsellTeaserText: 'Jetzt Sternzeichenkette auswählen',
            upsellSubmitText: 'Sternzeichenkette speichern',
            upsellCancelText: 'Nein, ich möchte keine Sternzeichenkette',
            upsellOverwriteIntroTitle: 'Sternschnuppe für',
            upsellOverlayStoerer: 'JETZT 30% sparen'
          }
        ],
        translations: [{ totalLabel: 'Total inkl. 19% MwSt.' }]
      }

      var selectedConfig = []
      if (location.pathname === '/products/sternschnuppe-silbernova') {
        selectedConfig = sternschnuppeBaseConfig
        selectedConfig.product = '8432574857484'
      } else if (location.pathname === '/products/sternschnuppe-supernova') {
        selectedConfig = sternschnuppeBaseConfig
        selectedConfig.product = '8432576200972'
      } else if (location.pathname === '/products/sternschnuppe-goldnova') {
        selectedConfig = sternschnuppeBaseConfig
        selectedConfig.product = '8432575447308'
      }

      config['sternschnuppe1'] = Object.assign({}, sternschnuppeBaseConfig)
      config['sternschnuppe1'].product = '8432574857484'
      config['sternschnuppe1'].upsellProducts = ['8440511234316', '8440511791372']

      config['sternschnuppe2'] = Object.assign({}, sternschnuppeBaseConfig)
      config['sternschnuppe2'].product = '8432575447308'
      config['sternschnuppe2'].upsellProducts = ['8446998937868']

      config['sternschnuppe3'] = Object.assign({}, sternschnuppeBaseConfig)
      config['sternschnuppe3'].product = '8432576200972'

      selectedConfig['translations'] = {
        'app.formelements.change.text': 'Ändern',
        'app.formelements.additional.qty': 'Anzahl',
        'app.formelements.imageselectbutton.noextracharge': 'Ohne Aufpreis',

        'app.basket.basket-group.title': 'Deine Sterntaufe',
        'app.basket.basket-group.remove-button-text': 'Entfernen',

        'app.basket.upsell-overlay.intro-title': 'Taufname',
        'app.basket.upsell-overlay.stoerer': 'JETZT 50% SPAREN',
        'app.basket.upsell-overlay.btn-yes-text': 'Ja, nehme ich',
        'app.basket.upsell-overlay.btn-no-text': 'Nein, abbrechen'
      }

      //Preis entfernen:
      $('#ProductPrice').attr('id', ' ')
      $('#ProductPrice').attr('orig-price', '')

      //
      var $mwProductOptions = $('.mw-product-options')
      $('<div class="configurator-app-container"></div>').insertAfter($('[id^="ProductSelect-"]'))
      $mwProductOptions.remove()

      //Additional Submit Button
      $('.product-form__controls-group.product-form__controls-group--submit').remove()

      //AddToCart Button
      var $AddToCartButtonNew = $(
        '<button type="submit" name="add" aria-label="In den Warenkorb legen" class="btn product-form__cart-submit configurator-submit-button" data-add-to-cart="">\n' +
          '                  <span data-add-to-cart-text="">\n' +
          '                    \n' +
          '                      In den Warenkorb legen\n' +
          '                    \n' +
          '                  </span>\n' +
          '                  <span class="hide" data-loader="">\n' +
          '                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg>\n' +
          '                  </span>\n' +
          '                </button>'
      )

      // $('.product-form__item--submit').prepend($AddToCartButtonNew);

      //$('form.product-form').after($AddToCartButtonNew)
      $('.mw-buy-button-container').append($AddToCartButtonNew)

      //$AddToCartButtonClone.attr('id', '');
      //$AddToCartButtonClone.prop('disabled', false)
      //$AddToCartButtonClone.addClass('configurator-submit-button');
      //$AddToCartButtonClone.prop('data-add-to-cart',false);
      //$AddToCartButtonClone.insertAfter( $('#AddToCart') );

      //Submit Button Bereich anzeigen:
      setInterval(function () {
        $('.product-form__controls-group--submit').show()

        //App Submit Button remove:
        $('#mwAddToCart').remove()
      }, 1000)

      var $sticky = $('<div class="rf-flagship-sticky"></div>')
      //
      $sticky.append($('.product-single__media-group').children())
      $('.product-single__media-group').append($sticky)

      //$AddToCartButton.css('display', 'block');
      //$AddToCartButton.css('visibility', 'visible');
      //$AddToCartButton.css('position', 'static');
      //$AddToCartButton.css('left', '0');

      //$('<div class="configurator-app-container"></div>');

      //console.dir('ShopifyConfiguratorController START BEFORE');

      var shopifyConfigurator = new ShopifyConfiguratorController(
        $('.configurator-app-container'),
        selectedConfig,
        config
      )

      console.dir('shopifyConfigurator started')
    })
  }
}, 500)
